export default "__VITE_ASSET__BJP0xjOi__"